import { CallEmsApi, iEmsApiResponseBody } from "./TenantAPI";

export interface GetConfigResponse {
    templates: Templates[];
    skins: Skins[];
    tags: Tags[];
    editorConfigs: EditorConfigs[];
}

export interface Templates {
    id: number;
    name: string;
    actions: number[];
    mailboxes: number[];
    updateAt: Date;
}
export interface Skins {
    id: number;
    name: string;
    mailboxes: number[];
    updateAt: Date;
}

export interface Tags {
    key: string;
    friendlyName: string;
    updateAt: Date;
}

export interface EditorConfigs {
    id: number;
    updateAt: Date;
}

export interface iMailboxConfig {
    alignmentEnabled: boolean;
    boldEnabled: boolean;
    bulletListEnabled: boolean;
    imageEnabled: boolean;
    italicEnabled: boolean;
    linkEnabled: boolean;
    numberListEnabled: boolean;
    tableEnabled: boolean;
    underlineEnabled: boolean;
    defaultFont: string;
    defaultFontSize?: string;
    availableBackColors: Array<{ label: string; hexCode: string }>;
    availableTextColors: Array<{ label: string; hexCode: string }>;
    availableFonts: [];
}

export interface iHtmlEditorConfig {
    Toolbar: string;
    BackColors: string[];
    TextColors: Array<string>;
    Fonts: [];
    DefaultFont: string;
    DefaultFontSize?: string;
}

export async function GetConfig(tenantToken: string): Promise<iEmsApiResponseBody<GetConfigResponse>> {
    return await CallEmsApi<GetConfigResponse>(tenantToken, "GET", `Config`);
}

export async function GetMailboxEditorConfig(
    tenantToken: string,
    sURL: string,
): Promise<iEmsApiResponseBody<iMailboxConfig>> {
    return await CallEmsApi<iMailboxConfig>(tenantToken, "GET", sURL);
}
